import { CommonFragments } from './common.fragments';

export class OverviewFragments {
  /*
   * GraphQL Fragment for the Overview Exhibit
   */
  public static readonly overviewFragment = `
    overviewExhibit {
      productObjective
      productDescription
      productStrategy
      asOfDate
      teamMembers {
        ${CommonFragments.teamMemberFragment}
      }
      ${CommonFragments.keyFactsFragment}
    }
  `;
}
